import { render, staticRenderFns } from "./SyncModuleMenu.vue?vue&type=template&id=8dd15816&"
import script from "./SyncModuleMenu.vue?vue&type=script&lang=js&"
export * from "./SyncModuleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports